module.exports = __webpack_public_path__ + "img/illinoisAdventure@2x.3f907b30.webp";